import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, empty, BehaviorSubject } from 'rxjs';
import {
  ICheckOutProcessModel,
  ICustomer,
  ICustomerAddress,
  IcheckoutOrderDetails,
  CheckOutProcessModel,
  IOrderDetail,
  ITaxCertificates,
  IOrderDetailsFormValidate,
  OrderDetailsFormValidate, BaseResponse, Customer
} from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { UserService } from './user.service';
import { catchError, map } from 'rxjs/operators';
import { HelperService } from './helper.service';
import { promise } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
 
 

  constructor(private httpClient: HttpClient,
    private helperService: HelperService,
    private userService: UserService) {
    this.checkOutProcessModel.userId = this.userService.readUserObject.userId;//current logged in userid
    this.checkOutProcessModel.customerNumber = this.userService.readUserObject.customerNumber;//customer id of current logged in user
  }
  public checkoutformState: {
    isShippingFormValid: boolean,
    isShippingFormSubmitted: boolean,
    isODFormValid: boolean,
    isODFormSubmitted: boolean,
    isRCFormValid: boolean,
    isRCFormSubmitted: boolean
  } = {
      isShippingFormValid: false,
      isShippingFormSubmitted: false,
      isODFormValid: false,
      isODFormSubmitted: false,
      isRCFormValid: false,
      isRCFormSubmitted: false,
    };
  // ICheckOutProcessModel
  public checkOutProcessModel: ICheckOutProcessModel = new CheckOutProcessModel();
  public promoCodeList: any[] = [];
  public orderDetailsForm: IOrderDetailsFormValidate = new OrderDetailsFormValidate()
  public minOrderFee: number = 0;
  public minOrderFeeMessage: string = ''
  promoCodeDiscount: number;
  promofreefreight: any;
  public validateODForm() {
    if (this.orderDetailsForm.isSubmitted) {
      this.checkoutformState.isODFormSubmitted = true;
      let isvalid = true;
      if (!this.checkOutProcessModel) {
        return;
      }
      if (!this.checkOutProcessModel.orderDetail) {
        return;
      }

      if (this.checkOutProcessModel.orderDetail.jobName) {
        this.orderDetailsForm.isInvalidJobName = false;

      } else {
        this.orderDetailsForm.isInvalidJobName = true;
        isvalid = false;

      }

      if (this.checkOutProcessModel.orderDetail.po) {
        this.orderDetailsForm.isInvalidPO = false;

      } else {
        this.orderDetailsForm.isInvalidPO = true;
        isvalid = false;
      }

      if (this.checkOutProcessModel.orderDetail.jobCity) {
        this.orderDetailsForm.isInvalidJobCity = false;

      } else {
        this.orderDetailsForm.isInvalidJobCity = true;
        isvalid = false;
      }
      const isStateSelected = this.checkOutProcessModel.orderDetail.jobState ? this.checkOutProcessModel.orderDetail.jobState.stateCode : "";
      if (isStateSelected) {
        this.orderDetailsForm.isInvalidJobState = false;

      } else {
        this.orderDetailsForm.isInvalidJobState = true;
        isvalid = false;
      }
      if (this.checkOutProcessModel.orderDetail.marketSegment) {
        this.orderDetailsForm.isInvalidMarketSegment = false;
      } else {
        this.orderDetailsForm.isInvalidMarketSegment = true;
        isvalid = false;
      }
      if (this.checkOutProcessModel.orderDetail.requestDateType) {
        this.orderDetailsForm.isInvalidRequestDateType = false;
      } else {
        this.orderDetailsForm.isInvalidRequestDateType = true;
        isvalid = false;
      }

      if (this.checkOutProcessModel.orderDetail.freightTerms) {
        this.orderDetailsForm.isInvalidFreightTerms = false;
        if (this.checkOutProcessModel.orderDetail.freightTerms.value == '4') {
          if (this.checkOutProcessModel.orderDetail.freightNotes) {
            this.orderDetailsForm.isInvalidFreightNotes = false;
          } else {
            this.orderDetailsForm.isInvalidFreightNotes = true;
          }
          if (this.orderDetailsForm.isInvalidFreightNotes == true) {
            isvalid = false;
          }
        }
      } else {
        this.orderDetailsForm.isInvalidFreightTerms = true;
        isvalid = false;
      }
      if (this.orderDetailsForm.isInvalidConfirmEmail == true) {
        isvalid = false;
      }
      if (this.orderDetailsForm.isInvalidRequestDate) {
        isvalid = false;
      }
      if (this.checkOutProcessModel.orderDetail.comments && this.checkOutProcessModel.orderDetail.comments.length > 120) {
        this.orderDetailsForm.isInvalidComments = false;
        isvalid = false;
      }
      if (isvalid) {
        this.checkoutformState.isODFormValid = true;
        return true;
      } else {
        this.checkoutformState.isODFormValid = false;
        return false;
      }
    }
    else {
      //everything is Invalid
      this.checkoutformState.isODFormSubmitted = false;
    }
  }


  public continueToReviewOrder() {
    this.orderDetailsForm.isSubmitted = true;
    return this.validateODForm();
  }

  //store shipping details

  public confirmCheckout(): Observable<any> {
    let cnfEmail = [];
    if (this.checkOutProcessModel.orderDetail.confirmEmail && this.checkOutProcessModel.orderDetail.confirmEmail.length > 0) {
      cnfEmail = this.sanitizeConfirmEmail(this.checkOutProcessModel.orderDetail.confirmEmail);
    }
    const data = {
      //userId: this.userService.readUserObject.userId,
      userName: this.userService.readUserObject.userName,
      customerNumber: this.userService.readUserObject.customerNumber,
      //shipToCustomerNumber: this.checkOutProcessModel.shipToCustomerNumber,
      //shipToCustomerName: this.checkOutProcessModel.currentShipping.customerName,
      billToCustomerNumber: this.checkOutProcessModel.billToCustomerNumber,
      billToCustomerName: this.checkOutProcessModel.currentBilling.customerName,
      shipToCustomer: this.checkOutProcessModel.currentShipping,
      billToCustomer: this.checkOutProcessModel.currentBilling,
      jobName: this.checkOutProcessModel.orderDetail.jobName,
      jobCity: this.checkOutProcessModel.orderDetail.jobCity,
      jobState: this.checkOutProcessModel.orderDetail.jobState.stateDescription,
      po: this.checkOutProcessModel.orderDetail.po,
      marketSegment: this.checkOutProcessModel.orderDetail.marketSegment.value,
      marketSegmentName: this.checkOutProcessModel.orderDetail.marketSegment.name,
      freightTerms: this.checkOutProcessModel.orderDetail.freightTerms.name,
      requestDate: this.checkOutProcessModel.orderDetail.requestDate,
      confirmEmail: cnfEmail,// this.checkOutProcessModel.orderDetail.confirmEmail,
      leed: this.checkOutProcessModel.orderDetail.leed,
      taxable: this.checkOutProcessModel.orderDetail.taxable,
      quotedInHouse: this.checkOutProcessModel.orderDetail.quotedInHouse,
      quoteNumber: this.checkOutProcessModel.orderDetail.quoteNumber,
      freightNotes: this.checkOutProcessModel.orderDetail.freightNotes,
      comments: this.checkOutProcessModel.orderDetail.comments,
      inputTax: this.checkOutProcessModel.orderDetail.inputTax,
      taxableCertification: this.checkOutProcessModel.orderDetail.taxableCertification,
      useCreditCard: this.checkOutProcessModel.orderDetail.useCreditCard,
      promoCode: this.checkOutProcessModel.orderDetail.promoCode ? this.checkOutProcessModel.orderDetail.promoCode : "",
      paymentTerms: this.checkOutProcessModel.currentBilling.paymentTerms,
      locationCode: this.checkOutProcessModel.currentBilling.locationCode,
      jobStateCode: this.checkOutProcessModel.orderDetail.jobState.stateCode,
      taxDocumentUrlPath: this.checkOutProcessModel.orderDetail.taxFile,
      taxFileName: this.checkOutProcessModel.orderDetail.taxFileName,
      orderTotal: this.checkOutProcessModel.orderTotal,
      requestDateType: this.checkOutProcessModel.orderDetail.requestDateType,
      sOShippingMethod: this.checkOutProcessModel.orderDetail.sOShippingMethod
    };
    //validate & transform as per api need

    //////////  //--file upload--------------
    //////////  const formData = new FormData();
    //////////  formData.append('userId', this.checkOutProcessModel.userId ? this.checkOutProcessModel.userId : '');
    //////////formData.append('customerNumber', this.checkOutProcessModel.customerNumber ? this.checkOutProcessModel.customerNumber : '');
    //////////formData.append('shipToCustomerNumber', this.checkOutProcessModel.shipToCustomerNumber ? this.checkOutProcessModel.shipToCustomerNumber.toString() : '');
    //////////formData.append('billToCustomerNumber', this.checkOutProcessModel.billToCustomerNumber ? this.checkOutProcessModel.billToCustomerNumber.toString() :'');
    //////////  formData.append('jobName', this.checkOutProcessModel.orderDetail.jobName ? this.checkOutProcessModel.orderDetail.jobName : '');
    //////////  formData.append('jobCity', this.checkOutProcessModel.orderDetail.jobCity ? this.checkOutProcessModel.orderDetail.jobCity : '');
    //////////  formData.append('jobState', this.checkOutProcessModel.orderDetail.jobState.stateDescription ? this.checkOutProcessModel.orderDetail.jobState.stateDescription : '');
    //////////  formData.append('po', this.checkOutProcessModel.orderDetail.po ? this.checkOutProcessModel.orderDetail.po : '');
    //////////  formData.append('marketSegment', this.checkOutProcessModel.orderDetail.marketSegment.name ? this.checkOutProcessModel.orderDetail.marketSegment.name : '');
    //////////  formData.append('freightTerms', this.checkOutProcessModel.orderDetail.freightTerms.name ? this.checkOutProcessModel.orderDetail.freightTerms.name : '');
    //////////formData.append('requestDate', this.checkOutProcessModel.orderDetail.requestDate ? this.checkOutProcessModel.orderDetail.requestDate.toString() : "");
    //////////  formData.append('confirmEmail', this.checkOutProcessModel.orderDetail.confirmEmail ? this.checkOutProcessModel.orderDetail.confirmEmail : '');
    //////////formData.append('leed', this.checkOutProcessModel.orderDetail.leed? this.checkOutProcessModel.orderDetail.leed.toString() : '');
    //////////formData.append('taxable', this.checkOutProcessModel.orderDetail.taxable ? this.checkOutProcessModel.orderDetail.taxable.toString() : '');
    //////////formData.append('quotedInHouse', this.checkOutProcessModel.orderDetail.quotedInHouse ? this.checkOutProcessModel.orderDetail.quotedInHouse.toString() : '');
    //////////  formData.append('quoteNumber', this.checkOutProcessModel.orderDetail.quoteNumber ? this.checkOutProcessModel.orderDetail.quoteNumber : '');
    //////////  formData.append('freightNotes', this.checkOutProcessModel.orderDetail.freightNotes ? this.checkOutProcessModel.orderDetail.freightNotes : '');
    //////////  formData.append('comments', this.checkOutProcessModel.orderDetail.comments ? this.checkOutProcessModel.orderDetail.comments : '');
    //////////  formData.append('inputTax', this.checkOutProcessModel.orderDetail.inputTax ? this.checkOutProcessModel.orderDetail.inputTax : '');
    //////////  formData.append('taxableCertification', this.checkOutProcessModel.orderDetail.taxableCertification ? this.checkOutProcessModel.orderDetail.taxableCertification : '');
    //////////formData.append('useCreditCard', this.checkOutProcessModel.orderDetail.useCreditCard ? this.checkOutProcessModel.orderDetail.useCreditCard.toString() : '');
    //////////  formData.append('promoCode', this.checkOutProcessModel.orderDetail.promoCode ? this.checkOutProcessModel.orderDetail.promoCode : '');
    //////////  formData.append('urlpath', this.checkOutProcessModel.orderDetail.file);
    //////////  if (this.checkOutProcessModel.orderDetail.file != null) {
    //////////    formData.append('file', this.checkOutProcessModel.orderDetail.file, this.checkOutProcessModel.orderDetail.file ? this.checkOutProcessModel.orderDetail.file.name : "");
    //////////  } else {
    //////////    formData.append('file', "");

    //////////}
    const apiEndpointFileUpload = ConfigService.APIs.endPoints.ORDER.CONFIRM_CHECKOUT;//ConfigService.APIs.endPoints.ORDER.SAVE_CHECKOUT_FILE_DELAY;
    return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
    ///}ric
    //--------------------------------End--------------

    //const apiEndpoint = ConfigService.APIs.endPoints.ORDER.CONFIRM_CHECKOUT;
    //return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data) as Observable<any>;
  }

  public confirmCheckoutChargeToAccount(): Observable<any> {

    let cnfEmail = [];
    if (this.checkOutProcessModel.orderDetail.confirmEmail && this.checkOutProcessModel.orderDetail.confirmEmail.length > 0) {
      cnfEmail = this.sanitizeConfirmEmail(this.checkOutProcessModel.orderDetail.confirmEmail);
    }
    if (!this.prepaidFreightSelected) {
      this.checkOutProcessModel.freightUniqueId = "";
      this.checkOutProcessModel.freightAmount = 0;
    }
    const data = {
      //userId: this.userService.readUserObject.userId,
      userName: this.userService.readUserObject.userName,
      customerNumber: this.userService.readUserObject.customerNumber,
      //shipToCustomerNumber: this.checkOutProcessModel.shipToCustomerNumber,
      //shipToCustomerName: this.checkOutProcessModel.currentShipping.customerName,
      billToCustomerNumber: this.checkOutProcessModel.billToCustomerNumber,
      billToCustomerName: this.checkOutProcessModel.currentBilling.customerName,
      shipToCustomer: this.checkOutProcessModel.currentShipping,
      billToCustomer: this.checkOutProcessModel.currentBilling,
      jobName: this.checkOutProcessModel.orderDetail.jobName,
      jobCity: this.checkOutProcessModel.orderDetail.jobCity,
      jobState: this.checkOutProcessModel.orderDetail.jobState.stateDescription,
      po: this.checkOutProcessModel.orderDetail.po,
      marketSegment: this.checkOutProcessModel.orderDetail.marketSegment.value,
      marketSegmentName: this.checkOutProcessModel.orderDetail.marketSegment.name,
      freightTerms: this.checkOutProcessModel.orderDetail.freightTerms.name,
      requestDate: this.checkOutProcessModel.orderDetail.requestDate,
      confirmEmail: cnfEmail,// this.checkOutProcessModel.orderDetail.confirmEmail,
      leed: this.checkOutProcessModel.orderDetail.leed,
      taxable: this.checkOutProcessModel.orderDetail.taxable,
      quotedInHouse: this.checkOutProcessModel.orderDetail.quotedInHouse,
      quoteNumber: this.checkOutProcessModel.orderDetail.quoteNumber,
      freightNotes: this.checkOutProcessModel.orderDetail.freightNotes,
      comments: this.checkOutProcessModel.orderDetail.comments,
      inputTax: this.checkOutProcessModel.orderDetail.inputTax,
      taxableCertification: this.checkOutProcessModel.orderDetail.taxableCertification,
      useCreditCard: this.checkOutProcessModel.orderDetail.useCreditCard,
      promoCode: this.checkOutProcessModel.orderDetail.promoCode ? this.checkOutProcessModel.orderDetail.promoCode : "",
      paymentTerms: this.checkOutProcessModel.currentBilling.paymentTerms,
      locationCode: this.checkOutProcessModel.currentBilling.locationCode,
      jobStateCode: this.checkOutProcessModel.orderDetail.jobState.stateCode,
      taxDocumentUrlPath: this.checkOutProcessModel.orderDetail.taxFile,
      taxFileName: this.checkOutProcessModel.orderDetail.taxFileName,
      orderTotal: this.checkOutProcessModel.orderTotal,
      freightUniqueId: this.checkOutProcessModel.freightUniqueId,
      freightValue: this.prepaidFreightSelected ? this.checkOutProcessModel.freightAmount : 0,//might rename to freightAmount
      requestDateType: this.checkOutProcessModel.orderDetail.requestDateType,
      sOShippingMethod: this.checkOutProcessModel.orderDetail.sOShippingMethod,
      minOrderFee: this.minOrderFee,
      minOrderFeeMessage: this.minOrderFeeMessage,
      promoCodeDiscount: this.promoCodeDiscount,
      promoCodeList: this.promoCodeList,
      promofreefreight: this.promofreefreight
    };
    
  
    //validate & transform as per api need

    //////////  //--file upload--------------
    //////////  const formData = new FormData();
    //////////  formData.append('userId', this.checkOutProcessModel.userId ? this.checkOutProcessModel.userId : '');
    //////////formData.append('customerNumber', this.checkOutProcessModel.customerNumber ? this.checkOutProcessModel.customerNumber : '');
    //////////formData.append('shipToCustomerNumber', this.checkOutProcessModel.shipToCustomerNumber ? this.checkOutProcessModel.shipToCustomerNumber.toString() : '');
    //////////formData.append('billToCustomerNumber', this.checkOutProcessModel.billToCustomerNumber ? this.checkOutProcessModel.billToCustomerNumber.toString() :'');
    //////////  formData.append('jobName', this.checkOutProcessModel.orderDetail.jobName ? this.checkOutProcessModel.orderDetail.jobName : '');
    //////////  formData.append('jobCity', this.checkOutProcessModel.orderDetail.jobCity ? this.checkOutProcessModel.orderDetail.jobCity : '');
    //////////  formData.append('jobState', this.checkOutProcessModel.orderDetail.jobState.stateDescription ? this.checkOutProcessModel.orderDetail.jobState.stateDescription : '');
    //////////  formData.append('po', this.checkOutProcessModel.orderDetail.po ? this.checkOutProcessModel.orderDetail.po : '');
    //////////  formData.append('marketSegment', this.checkOutProcessModel.orderDetail.marketSegment.name ? this.checkOutProcessModel.orderDetail.marketSegment.name : '');
    //////////  formData.append('freightTerms', this.checkOutProcessModel.orderDetail.freightTerms.name ? this.checkOutProcessModel.orderDetail.freightTerms.name : '');
    //////////formData.append('requestDate', this.checkOutProcessModel.orderDetail.requestDate ? this.checkOutProcessModel.orderDetail.requestDate.toString() : "");
    //////////  formData.append('confirmEmail', this.checkOutProcessModel.orderDetail.confirmEmail ? this.checkOutProcessModel.orderDetail.confirmEmail : '');
    //////////formData.append('leed', this.checkOutProcessModel.orderDetail.leed? this.checkOutProcessModel.orderDetail.leed.toString() : '');
    //////////formData.append('taxable', this.checkOutProcessModel.orderDetail.taxable ? this.checkOutProcessModel.orderDetail.taxable.toString() : '');
    //////////formData.append('quotedInHouse', this.checkOutProcessModel.orderDetail.quotedInHouse ? this.checkOutProcessModel.orderDetail.quotedInHouse.toString() : '');
    //////////  formData.append('quoteNumber', this.checkOutProcessModel.orderDetail.quoteNumber ? this.checkOutProcessModel.orderDetail.quoteNumber : '');
    //////////  formData.append('freightNotes', this.checkOutProcessModel.orderDetail.freightNotes ? this.checkOutProcessModel.orderDetail.freightNotes : '');
    //////////  formData.append('comments', this.checkOutProcessModel.orderDetail.comments ? this.checkOutProcessModel.orderDetail.comments : '');
    //////////  formData.append('inputTax', this.checkOutProcessModel.orderDetail.inputTax ? this.checkOutProcessModel.orderDetail.inputTax : '');
    //////////  formData.append('taxableCertification', this.checkOutProcessModel.orderDetail.taxableCertification ? this.checkOutProcessModel.orderDetail.taxableCertification : '');
    //////////formData.append('useCreditCard', this.checkOutProcessModel.orderDetail.useCreditCard ? this.checkOutProcessModel.orderDetail.useCreditCard.toString() : '');
    //////////  formData.append('promoCode', this.checkOutProcessModel.orderDetail.promoCode ? this.checkOutProcessModel.orderDetail.promoCode : '');
    //////////  formData.append('urlpath', this.checkOutProcessModel.orderDetail.file);
    //////////  if (this.checkOutProcessModel.orderDetail.file != null) {
    //////////    formData.append('file', this.checkOutProcessModel.orderDetail.file, this.checkOutProcessModel.orderDetail.file ? this.checkOutProcessModel.orderDetail.file.name : "");
    //////////  } else {
    //////////    formData.append('file', "");

    //////////}
    const apiEndpointFileUpload = ConfigService.APIs.endPoints.ORDER.CONFIRM_CHECKOUT_CHARGETOACCOUNT;//ConfigService.APIs.endPoints.ORDER.SAVE_CHECKOUT_FILE_DELAY;
    return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
    ///}ric
    //--------------------------------End--------------

    //const apiEndpoint = ConfigService.APIs.endPoints.ORDER.CONFIRM_CHECKOUT;
    //return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data) as Observable<any>;
  }


  public sanitizeConfirmEmail(emails) {
    let finalEmail = [];
    try {
      for (var i = 0; i < emails.length; i++) {
        let e = emails[i].toLowerCase().trim();//remove space and make it lowercase
        if (this.helperService.validateEmail(e)) {
          finalEmail.push(e);
        }
      }
    }
    catch (e) { }
    return finalEmail;
  }

  public expressCheckout(model: ICheckOutProcessModel, quoteCommonId: string): Observable<any> {
    let cnfEmail = [];
    if (model.orderDetail.confirmEmail && model.orderDetail.confirmEmail.length > 0) {
      cnfEmail = this.sanitizeConfirmEmail(model.orderDetail.confirmEmail);
    }
    const data = {
      //userId: this.userService.readUserObject.userId,
      userName: this.userService.readUserObject.userName,
      customerNumber: this.userService.readUserObject.customerNumber,
      //shipToCustomerNumber: this.model.shipToCustomerNumber,
      //shipToCustomerName: this.model.currentShipping.customerName,
      billToCustomerNumber: model.billToCustomerNumber,
      billToCustomerName: model.currentBilling.customerName,
      billToCustomer: model.currentBilling,
      shipToCustomer: model.currentShipping,
      jobName: model.orderDetail.jobName,
      jobCity: model.orderDetail.jobCity,
      jobState: model.orderDetail.jobState.stateDescription,
      po: model.orderDetail.po,
      marketSegment: model.orderDetail.marketSegment.value,
      marketSegmentName: model.orderDetail.marketSegment.name,
      freightTerms: model.orderDetail.freightTerms.name,
      requestDate: model.orderDetail.requestDate,
      confirmEmail: cnfEmail,//model.orderDetail.confirmEmail,
      leed: model.orderDetail.leed,
      taxable: model.orderDetail.taxable,
      quotedInHouse: model.orderDetail.quotedInHouse,
      quoteNumber: model.orderDetail.quoteNumber,
      freightNotes: model.orderDetail.freightNotes,
      comments: model.orderDetail.comments,
      inputTax: model.orderDetail.inputTax,
      taxableCertification: model.orderDetail.taxableCertification,
      useCreditCard: model.orderDetail.useCreditCard,
      promoCode: model.orderDetail.promoCode ? model.orderDetail.promoCode : "",
      paymentTerms: model.currentBilling.paymentTerms,
      locationCode: model.currentBilling.locationCode,
      jobStateCode: model.orderDetail.jobState.stateCode,
      taxDocumentUrlPath: model.orderDetail.taxFile,
      taxFileName: model.orderDetail.taxFileName,
      orderTotal: model.orderTotal,
      sourceQuoteCommonId: quoteCommonId,
      requestDateType: model.orderDetail.requestDateType,
      sOShippingMethod: model.orderDetail.sOShippingMethod
    };
    console.log(data);
    const apiEndpointFileUpload = ConfigService.APIs.endPoints.ORDER.EXPRESS_CHECKOUT;//ConfigService.APIs.endPoints.ORDER.SAVE_CHECKOUT_FILE_DELAY;
    return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
  }

  public expressCheckoutChargeToAccount(model: ICheckOutProcessModel, quoteCommonId: string): Observable<any> {
    let cnfEmail = [];
    if (model.orderDetail.confirmEmail && model.orderDetail.confirmEmail.length > 0) {
      cnfEmail = this.sanitizeConfirmEmail(model.orderDetail.confirmEmail);
    }
    if (!this.prepaidFreightSelected) {
      this.checkOutProcessModel.freightUniqueId = "";
      this.checkOutProcessModel.freightAmount = 0;
    }
    const data = {
      //userId: this.userService.readUserObject.userId,
      userName: this.userService.readUserObject.userName,
      customerNumber: this.userService.readUserObject.customerNumber,
      //shipToCustomerNumber: this.model.shipToCustomerNumber,
      //shipToCustomerName: this.model.currentShipping.customerName,
      billToCustomerNumber: model.billToCustomerNumber,
      billToCustomerName: model.currentBilling.customerName,
      billToCustomer: model.currentBilling,
      shipToCustomer: model.currentShipping,
      jobName: model.orderDetail.jobName,
      jobCity: model.orderDetail.jobCity,
      jobState: model.orderDetail.jobState.stateDescription,
      po: model.orderDetail.po,
      marketSegment: model.orderDetail.marketSegment.value,
      marketSegmentName: model.orderDetail.marketSegment.name,
      freightTerms: model.orderDetail.freightTerms.name,
      requestDate: model.orderDetail.requestDate,
      confirmEmail: cnfEmail,//model.orderDetail.confirmEmail,
      leed: model.orderDetail.leed,
      taxable: model.orderDetail.taxable,
      quotedInHouse: model.orderDetail.quotedInHouse,
      quoteNumber: model.orderDetail.quoteNumber,
      freightNotes: model.orderDetail.freightNotes,
      comments: model.orderDetail.comments,
      inputTax: model.orderDetail.inputTax,
      taxableCertification: model.orderDetail.taxableCertification,
      useCreditCard: model.orderDetail.useCreditCard,
      promoCode: model.orderDetail.promoCode ? model.orderDetail.promoCode : "",
      paymentTerms: model.currentBilling.paymentTerms,
      locationCode: model.currentBilling.locationCode,
      jobStateCode: model.orderDetail.jobState.stateCode,
      taxDocumentUrlPath: model.orderDetail.taxFile,
      taxFileName: model.orderDetail.taxFileName,
      orderTotal: model.orderTotal,
      sourceQuoteCommonId: quoteCommonId,
      freightUniqueId: this.checkOutProcessModel.freightUniqueId,
      freightValue: this.checkOutProcessModel.freightAmount,
      requestDateType: model.orderDetail.requestDateType,
      sOShippingMethod: model.orderDetail.sOShippingMethod,
      minOrderFee: this.minOrderFee,
      minOrderFeeMessage: this.minOrderFeeMessage,
      promoCodeDiscount: this.promoCodeDiscount,
      promoCodeList: this.promoCodeList,
      promofreefreight: this.promofreefreight
    };
    console.log(data);
    const apiEndpointFileUpload = ConfigService.APIs.endPoints.ORDER.EXPRESS_CHECKOUT_CHARGETOACCOUNT;//ConfigService.APIs.endPoints.ORDER.SAVE_CHECKOUT_FILE_DELAY;
    return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
  }


  public reset() {
    this.checkOutProcessModel = new CheckOutProcessModel();
    this.checkoutformState = {
      isShippingFormValid: false,
      isShippingFormSubmitted: false,
      isODFormValid: false,
      isODFormSubmitted: false,
      isRCFormValid: false,
      isRCFormSubmitted: false,
    };
  }

  public checkPromoCode(promoCode: string): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.ORDER.VALIDATE_PROMOCODE}/${promoCode}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public async searchtaxCertificate(): Promise<any> {
    const endPoint = `${ConfigService.APIs.endPoints.ORDER.GET_TAX_CERTIFICATES}`;
    const customerNumber: string = this.userService.readUserObject.customerNumber;
    var body = { Name: customerNumber };
    let confirmResp;
    await (ApiService.genericObservablePost(this.httpClient, endPoint, body).toPromise()).then((r) => {
      confirmResp = r;
    }).catch((e) => {
      if (e.status === 401 || e.status === 403) {
        confirmResp = e.error;
      }
    });
    return confirmResp;
  }


  //#region Credit Card Phase 3 related methods & variables


  //#region Ship To Change handler
  defaultCustomer: ICustomer = new Customer();
  public shipToChangeSubject: BehaviorSubject<ICustomer> = new BehaviorSubject<ICustomer>(
    this.defaultCustomer
  );
  //#endregion
  //#region Freight Amount Change handler
  defaultFreightAmt: Number = 0;
  public freightAmountChangeSubject: BehaviorSubject<Number> = new BehaviorSubject<Number>(
    this.defaultFreightAmt
  );
  //#endregion
  //#region Freight Calculation
  freightCalcInProgress: boolean = false;
  freightCalcSuccess: boolean = false;
  freightCalcError: boolean = false;

  prepaidFreightCalcSuccess: boolean = false;
  prepaidFreightSelected: boolean = false;
  public calculateFreightAmountByOrder(isExpressCheckoutVal: boolean): Observable<any> {
    const data = {
      userName: this.userService.readUserObject.userName,
      customerNumber: this.userService.readUserObject.customerNumber,
      billToCustomerNumber: this.checkOutProcessModel.billToCustomerNumber,
      billToCustomerName: this.checkOutProcessModel.currentBilling.customerName,
      shipToCustomer: this.checkOutProcessModel.currentShipping,
      billToCustomer: this.checkOutProcessModel.currentBilling,
      leed: this.checkOutProcessModel.orderDetail.leed,
      orderTotal: this.checkOutProcessModel.orderTotal,
      isExpressCheckout: isExpressCheckoutVal
    };
    const apiEndpointFileUpload = ConfigService.APIs.endPoints.ORDER.CALCULATE_FREIGHT_AMOUNT;
    return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
  }
  public calculateFreightAmountForExpressCheckout(model: ICheckOutProcessModel, quoteCommonId: string, isExpressCheckoutVal: boolean): Observable<any> {
    console.log(this.checkOutProcessModel);
    console.log(model);
    const data = {
      userName: this.userService.readUserObject.userName,
      customerNumber: this.userService.readUserObject.customerNumber,
      billToCustomerNumber: model.billToCustomerNumber,
      billToCustomerName: model.currentBilling.customerName,
      billToCustomer: model.currentBilling,
      shipToCustomer: model.currentShipping,
      jobName: model.orderDetail.jobName,
      leed: model.orderDetail.leed,
      quotedInHouse: model.orderDetail.quotedInHouse,
      quoteNumber: model.orderDetail.quoteNumber,
      sourceQuoteCommonId: quoteCommonId,
      isExpressCheckout: isExpressCheckoutVal,
    };
    const apiEndpointFileUpload = ConfigService.APIs.endPoints.ORDER.CALCULATE_FREIGHT_AMOUNT;
    return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
  }
  public resetFreightCalcFlags() {
    this.freightCalcInProgress = false;
    this.freightCalcSuccess = false;
    this.freightCalcError = false;
  }
  //#endregion
  //#region Methods related to checkout that are paid with a Credit Card
  ccActionUrl: string = '';
  ccRequestId: string = '';
  ccTrackerId: string = '';
  browserName: string = '';
  public validateODFormForOrdersPaidWithCC() {
    if (this.orderDetailsForm.isSubmitted) {
      this.checkoutformState.isODFormSubmitted = true;
      let isvalid = true;
      if (!this.checkOutProcessModel) {
        return;
      }
      if (!this.checkOutProcessModel.orderDetail) {
        return;
      }
      if (this.checkOutProcessModel.orderDetail.jobName) {
        this.orderDetailsForm.isInvalidJobName = false;
      } else {
        this.orderDetailsForm.isInvalidJobName = true;
        isvalid = false;
      }
      if (this.checkOutProcessModel.orderDetail.po) {
        this.orderDetailsForm.isInvalidPO = false;
      } else {
        this.orderDetailsForm.isInvalidPO = true;
        isvalid = false;
      }
      if (this.checkOutProcessModel.orderDetail.jobCity) {
        this.orderDetailsForm.isInvalidJobCity = false;
      } else {
        this.orderDetailsForm.isInvalidJobCity = true;
        isvalid = false;
      }
      const isStateSelected = this.checkOutProcessModel.orderDetail.jobState ? this.checkOutProcessModel.orderDetail.jobState.stateCode : "";
      if (isStateSelected) {
        this.orderDetailsForm.isInvalidJobState = false;
      } else {
        this.orderDetailsForm.isInvalidJobState = true;
        isvalid = false;
      }
      if (this.checkOutProcessModel.orderDetail.marketSegment) {
        this.orderDetailsForm.isInvalidMarketSegment = false;
      } else {
        this.orderDetailsForm.isInvalidMarketSegment = true;
        isvalid = false;
      }
      if (this.checkOutProcessModel.orderDetail.requestDateType) {
        this.orderDetailsForm.isInvalidRequestDateType = false;
      } else {
        this.orderDetailsForm.isInvalidRequestDateType = true;
        isvalid = false;
      }
      if (this.checkOutProcessModel.orderDetail.freightTerms) {
        this.orderDetailsForm.isInvalidFreightTerms = false;
      } else {
        this.orderDetailsForm.isInvalidFreightTerms = true;
        isvalid = false;
      }
      if (this.orderDetailsForm.isInvalidConfirmEmail == true) {
        isvalid = false;
      }
      if (this.checkOutProcessModel.orderDetail.comments && this.checkOutProcessModel.orderDetail.comments.length > 120) {
        this.orderDetailsForm.isInvalidComments = false;
        isvalid = false;
      }
      //validation related to Freight Calc start
      this.orderDetailsForm.isFreightCalcSuccessfull = true;
      if (this.prepaidFreightSelected) {
        if (!this.prepaidFreightCalcSuccess) {
          this.orderDetailsForm.isFreightCalcSuccessfull = false;
          isvalid = false;
        }
      }
      /*prepaidFreightCalcInProgress, prepaidFreightCalcError, prepaidFreightCalcSuccess*/
      //validation related to Freight Calc end
      if (isvalid) {
        this.checkoutformState.isODFormValid = true;
        this.checkOutProcessModel.creditCardCharge = (this.checkOutProcessModel.orderTotal + this.checkOutProcessModel.freightAmount + this.minOrderFee) * 3 / 100;
        return true;
      } else {
        this.checkoutformState.isODFormValid = false;
        return false;
      }
    }
    else {
      //everything is Invalid
      this.checkoutformState.isODFormSubmitted = false;
    }
  }
  public getCreditCardCheckOutRequestId(): Observable<any> {
    let cnfEmail = [];
    if (this.checkOutProcessModel.orderDetail.confirmEmail && this.checkOutProcessModel.orderDetail.confirmEmail.length > 0) {
      cnfEmail = this.sanitizeConfirmEmail(this.checkOutProcessModel.orderDetail.confirmEmail);
    }
    let paymentTerm = this.checkOutProcessModel.currentBilling.paymentTerms;
    if (paymentTerm == 'CIA') {
      paymentTerm = 'CCA';
    } else {
      if (this.userService.isCheckoutCCCustomer() && paymentTerm != 'CCA')
        paymentTerm = 'CC';
      if (this.userService.isCheckoutCConlyCustomer())
        paymentTerm = 'CCA';
    }
      const data = {
        userName: this.userService.readUserObject.userName,
        customerNumber: this.userService.readUserObject.customerNumber,
        billToCustomerNumber: this.checkOutProcessModel.billToCustomerNumber,
        billToCustomerName: this.checkOutProcessModel.currentBilling.customerName,
        shipToCustomer: this.checkOutProcessModel.currentShipping,
        billToCustomer: this.checkOutProcessModel.currentBilling,
        jobName: this.checkOutProcessModel.orderDetail.jobName,
        jobCity: this.checkOutProcessModel.orderDetail.jobCity,
        jobState: this.checkOutProcessModel.orderDetail.jobState.stateDescription,
        po: this.checkOutProcessModel.orderDetail.po,
        marketSegment: this.checkOutProcessModel.orderDetail.marketSegment.value,
        marketSegmentName: this.checkOutProcessModel.orderDetail.marketSegment.name,
        freightTerms: this.checkOutProcessModel.orderDetail.freightTerms.name,
        requestDate: this.checkOutProcessModel.orderDetail.requestDate,
        confirmEmail: cnfEmail,
        leed: this.checkOutProcessModel.orderDetail.leed,
        taxable: this.checkOutProcessModel.orderDetail.taxable,
        quotedInHouse: this.checkOutProcessModel.orderDetail.quotedInHouse,
        quoteNumber: this.checkOutProcessModel.orderDetail.quoteNumber,
        freightNotes: this.checkOutProcessModel.orderDetail.freightNotes,
        comments: this.checkOutProcessModel.orderDetail.comments,
        inputTax: this.checkOutProcessModel.orderDetail.inputTax,
        taxableCertification: this.checkOutProcessModel.orderDetail.taxableCertification,
        useCreditCard: this.checkOutProcessModel.orderDetail.useCreditCard,
        promoCode: this.checkOutProcessModel.orderDetail.promoCode ? this.checkOutProcessModel.orderDetail.promoCode : "",
        paymentTerms: paymentTerm,
        locationCode: this.checkOutProcessModel.currentBilling.locationCode,
        jobStateCode: this.checkOutProcessModel.orderDetail.jobState.stateCode,
        taxDocumentUrlPath: this.checkOutProcessModel.orderDetail.taxFile,
        taxFileName: this.checkOutProcessModel.orderDetail.taxFileName,
        orderTotal: this.checkOutProcessModel.orderTotal,
        freightValue: this.prepaidFreightSelected ? this.checkOutProcessModel.freightAmount : 0,//might rename to freightAmount
        creditCardCharge: this.checkOutProcessModel.creditCardCharge,
        freightUniqueId: this.checkOutProcessModel.freightUniqueId,
        requestDateType: this.checkOutProcessModel.orderDetail.requestDateType,
        sOShippingMethod: this.checkOutProcessModel.orderDetail.sOShippingMethod,
        isExpressCheckOut: false,
        minOrderFee: this.minOrderFee,
        minOrderFeeMessage: this.minOrderFeeMessage,
        promoCodeDiscount: this.promoCodeDiscount,
        promoCodeList: this.promoCodeList,
        promofreefreight: this.promofreefreight
    };
      const apiEndpointFileUpload = ConfigService.APIs.endPoints.ORDER.GET_CREDIT_CARD_CHECKOUT_REQUEST_ID;///order/getcreditcardcheckoutrequestid;
      return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
    }
  public getCreditCardExpressCheckOutRequestId(model: ICheckOutProcessModel, quoteCommonId: string): Observable<any> {
    let cnfEmail = [];
    if (model.orderDetail.confirmEmail && model.orderDetail.confirmEmail.length > 0) {
      cnfEmail = this.sanitizeConfirmEmail(model.orderDetail.confirmEmail);
    }
    let paymentTerm = model.currentBilling.paymentTerms;
    if (paymentTerm == 'CIA') {
      paymentTerm = 'CCA';
    } else {
      if (this.userService.isCheckoutCCCustomer() && paymentTerm != 'CCA')
        paymentTerm = 'CC';
      if (this.userService.isCheckoutCConlyCustomer())
        paymentTerm = 'CCA';
    }
      const data = {
        userName: this.userService.readUserObject.userName,
        customerNumber: this.userService.readUserObject.customerNumber,
        billToCustomerNumber: model.billToCustomerNumber,
        billToCustomerName: model.currentBilling.customerName,
        billToCustomer: model.currentBilling,
        shipToCustomer: model.currentShipping,
        jobName: model.orderDetail.jobName,
        jobCity: model.orderDetail.jobCity,
        jobState: model.orderDetail.jobState.stateDescription,
        po: model.orderDetail.po,
        marketSegment: model.orderDetail.marketSegment.value,
        marketSegmentName: model.orderDetail.marketSegment.name,
        freightTerms: model.orderDetail.freightTerms.name,
        requestDate: model.orderDetail.requestDate,
        confirmEmail: cnfEmail,
        leed: model.orderDetail.leed,
        taxable: model.orderDetail.taxable,
        quotedInHouse: model.orderDetail.quotedInHouse,
        quoteNumber: model.orderDetail.quoteNumber,
        freightNotes: model.orderDetail.freightNotes,
        comments: model.orderDetail.comments,
        inputTax: model.orderDetail.inputTax,
        taxableCertification: model.orderDetail.taxableCertification,
        useCreditCard: model.orderDetail.useCreditCard,
        promoCode: model.orderDetail.promoCode ? model.orderDetail.promoCode : "",
        paymentTerms: paymentTerm,
        locationCode: model.currentBilling.locationCode,
        jobStateCode: model.orderDetail.jobState.stateCode,
        taxDocumentUrlPath: model.orderDetail.taxFile,
        taxFileName: model.orderDetail.taxFileName,
        orderTotal: model.orderTotal,
        sourceQuoteCommonId: quoteCommonId,
        freightValue: this.prepaidFreightSelected ? this.checkOutProcessModel.freightAmount : 0,//might rename to freightAmount
        creditCardCharge: this.checkOutProcessModel.creditCardCharge,
        freightUniqueId: model.freightUniqueId,
        requestDateType: model.orderDetail.requestDateType,
        sOShippingMethod: model.orderDetail.sOShippingMethod,
        isExpressCheckOut: true,
        minOrderFee: this.minOrderFee,
        minOrderFeeMessage: this.minOrderFeeMessage,
        promoCodeDiscount: this.promoCodeDiscount,
        promoCodeList: this.promoCodeList,
        promofreefreight: this.promofreefreight
      };
      console.log(data);
      const apiEndpointFileUpload = ConfigService.APIs.endPoints.ORDER.GET_CREDIT_CARD_CHECKOUT_REQUEST_ID;//ConfigService.APIs.endPoints.ORDER.SAVE_CHECKOUT_FILE_DELAY;
      return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
    }
    cancelCreditCardCheckout(data: any) {
      const apiEndpointFileUpload = ConfigService.APIs.endPoints.ORDER.CANCEL_CREDIT_CARD_CHECKOUT;
      return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
    }
    completeCreditCardCheckout(data: any) {
      const apiEndpointFileUpload = ConfigService.APIs.endPoints.ORDER.COMPLETE_CREDIT_CARD_CHECKOUT; //"/InvoicePayment/CreditCardCompleteTransaction";
      return ApiService.genericObservablePost(this.httpClient, apiEndpointFileUpload, data) as Observable<any>;
    }
    //#endregion

    //#endregion
  }

